import React from "react";

const MyModerationsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.109"
      height="40.336"
      viewBox="0 0 36.109 40.336"
    >
      <g id="db87" transform="translate(-180.326 -157.427)">
        <path
          id="Path_1774"
          data-name="Path 1774"
          d="M204.544,206.15h-.176v1.74a4.324,4.324,0,0,1-4.32,4.319H187.461a4.324,4.324,0,0,1-4.32-4.319v-1.74h-.176a2.643,2.643,0,0,0-2.639,2.639v30.563a2.638,2.638,0,0,0,2.639,2.639h21.58a2.638,2.638,0,0,0,2.639-2.639V208.789a2.643,2.643,0,0,0-2.639-2.639Zm-1.857,26.017a.843.843,0,0,1-.84.84h-3.6a.843.843,0,0,1-.84-.84v-3.6a.837.837,0,0,1,.84-.84h.957v-2.463H188.3v2.463h.956a.837.837,0,0,1,.84.84v3.6a.843.843,0,0,1-.84.84h-3.6a.843.843,0,0,1-.84-.84v-3.6a.837.837,0,0,1,.84-.84h.96v-3.3a.84.84,0,0,1,.84-.84h5.452v-3.167h-.958a.843.843,0,0,1-.84-.84v-3.6a.843.843,0,0,1,.84-.84h3.6a.843.843,0,0,1,.84.84v3.6a.843.843,0,0,1-.84.84h-.958v3.167h5.452a.84.84,0,0,1,.84.84v3.3h.959a.837.837,0,0,1,.84.84Z"
          transform="translate(0 -44.228)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1775"
          data-name="Path 1775"
          d="M246.92,160.965v2.7a2.643,2.643,0,0,1-2.639,2.639H231.693a2.643,2.643,0,0,1-2.639-2.639v-2.7a.843.843,0,0,1,.84-.84h2.7l.059-.958a1.743,1.743,0,0,1,1.74-1.74h7.193a1.743,1.743,0,0,1,1.739,1.739v.9l2.756.059a.843.843,0,0,1,.841.841Z"
          transform="translate(-44.232)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1776"
          data-name="Path 1776"
          d="M499.421,157.43h-1.8a2.643,2.643,0,0,0-2.639,2.639v3.193a.837.837,0,0,0,.84.84h5.395a.832.832,0,0,0,.84-.84v-3.193A2.643,2.643,0,0,0,499.421,157.43Z"
          transform="translate(-285.625 -0.003)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1777"
          data-name="Path 1777"
          d="M495.844,267.894h5.369a2.487,2.487,0,0,1,.849.167V246.269a2.5,2.5,0,0,1-.841.155h-5.395a2.485,2.485,0,0,1-.84-.155V268.06a2.547,2.547,0,0,1,.857-.166Z"
          transform="translate(-285.627 -80.645)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1778"
          data-name="Path 1778"
          d="M502.165,499.988l-2.681,7.151a.847.847,0,0,1-.79.546.835.835,0,0,1-.781-.546l-2.689-7.151a.845.845,0,0,1,.1-.773.827.827,0,0,1,.689-.362h5.37a.836.836,0,0,1,.781,1.135Z"
          transform="translate(-285.796 -309.923)"
          fill={fill ? fill : "#a07eff"}
        />
      </g>
    </svg>
  );
};

export default MyModerationsIcon;
